export default function renderingInServer() {
  return typeof window === 'undefined';
}
